import { Helmet } from "react-helmet-async";
import Skeleton from "../../components/Skeleton";
import "./Player.css";
import she from "./playImage/she.png";
import { NavLink, useParams, useLocation } from "react-router-dom";
import logo from "../../components/images/logo.png";

const Player = ({ dark, playerData, loading, error, MyBaseUrl }) => {
  const { slug } = useParams();
  const location = useLocation();

  const createSlug = (name) => {
    return name
      ?.toLowerCase()
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]/g, "");
  };

  const fallbackPlayer = location?.state?.player || {};

  const player = playerData || {};
  const stats = playerData?.statistics?.[0] || {};
  const team = stats?.team || {};

  const passedLeagueSlug = location?.state?.leagueSlug;

  const fallbackSlug =
    stats?.league?.name?.trim()?.toLowerCase()?.replace(/\s+/g, "") || "";

  const leagueSlug = passedLeagueSlug || fallbackSlug;

  return (
    <>
      <Helmet>
        <title>
          {`${fallbackPlayer?.name || player?.name || "Player"} Stats, Profile, Goals & Career Updates | FadaSports`}
        </title>

        <meta
          name="description"
          content={`Explore ${
            fallbackPlayer?.name || player?.name || "this player"
          }'s full football profile including stats, goals, assists, appearances, ratings, biography, and career performance for ${
            team?.name || "their club"
          } in ${stats?.league?.name || "top competitions"} on FadaSports.`}
        />

        <meta
          name="keywords"
          content={`
      ${fallbackPlayer?.name || player?.name},
      ${team?.name || ""},
      ${stats?.league?.name || ""},
      football player stats,
      player profile,
      goals,
      assists,
      appearances,
      football biography,
      transfer updates,
      performance analysis,
      sports media,
      FadaSports
    `}
        />

        <meta name="author" content="FadaSports" />

        <meta name="robots" content="index, follow, max-image-preview:large" />

        <meta name="theme-color" content="#000000" />

        <link rel="canonical" href={`https://fadasports.com/player/${slug}`} />

        <meta property="og:type" content="profile" />

        <meta property="og:site_name" content="FadaSports" />

        <meta
          property="og:url"
          content={`https://fadasports.com/player/${slug}`}
        />

        <meta
          property="og:title"
          content={`${fallbackPlayer?.name || player?.name || "Player"} Stats, Profile & Career | FadaSports`}
        />

        <meta
          property="og:description"
          content={`Full football profile of ${
            fallbackPlayer?.name || player?.name || "this player"
          } including stats, goals, assists, ratings and career history.`}
        />

        <meta
          property="og:image"
          content="https://fadasports.com/static/media/mobilelogo.d0257d49e02d3094cce0.png"
        />

        <meta
          property="og:image:alt"
          content={`${fallbackPlayer?.name || player?.name || "Player"} profile`}
        />

        <meta property="og:locale" content="en_US" />

        <meta name="twitter:card" content="summary_large_image" />

        <meta
          name="twitter:title"
          content={`${fallbackPlayer?.name || player?.name || "Player"} Stats & Profile | FadaSports`}
        />

        <meta
          name="twitter:description"
          content={`View ${
            fallbackPlayer?.name || player?.name || "player"
          }'s stats, goals, assists, appearances and football career updates.`}
        />

        <meta
          name="twitter:image"
          content={fallbackPlayer?.photo || player?.photo || { logo }}
        />

        <meta name="twitter:site" content="@FadaSports" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Person",

            name: fallbackPlayer?.name || player?.name || "Football Player",

            image:
              fallbackPlayer?.photo ||
              player?.photo ||
              "https://fadasports.com/default-player.jpg",

            url: `https://fadasports.com/player/${slug}`,

            nationality:
              player?.nationality || fallbackPlayer?.nationality || "",

            birthPlace: {
              "@type": "Place",
              name: player?.nationality || fallbackPlayer?.nationality || "",
            },

            jobTitle: "Professional Football Player",

            worksFor: {
              "@type": "SportsTeam",
              name: team?.name || fallbackPlayer?.team?.name || "",
            },

            memberOf: {
              "@type": "SportsOrganization",
              name: stats?.league?.name || "",
            },

            description: `${
              fallbackPlayer?.name || player?.name || "This player"
            } football profile, including stats, goals, assists, ratings, biography and career performance on FadaSports.`,

            sameAs: ["https://fadasports.com"],
          })}
        </script>
      </Helmet>

      <div className="playerWrapper" id="playerWrapper">
        <section
          className="firstsection"
          style={{
            position: "sticky",
          }}>
          <nav>
            <img
              src={fallbackPlayer?.photo || player?.photo}
              alt={player?.name}
            />
            <div>
              <p style={dark ? { color: "#fafafaff" } : { color: "#161819" }}>
                {fallbackPlayer?.name || player?.name}
              </p>
            </div>
          </nav>

          <span>
            <strong
              style={dark ? { color: "#c7c7c7ff" } : { color: "#363636ff" }}>
              {player?.age || fallbackPlayer?.age
                ? `${player?.age || fallbackPlayer?.age} years`
                : "Loading..."}{" "}
              {player?.nationality || fallbackPlayer?.nationality || ""}
            </strong>

            <strong
              style={dark ? { color: "#c5c3c3ff" } : { color: "#3a3a3aff" }}>
              {team?.name || fallbackPlayer?.team?.name || ""}
            </strong>
          </span>

          <menu>
            <ul style={dark ? { backgroundColor: "#333333ff" } : {}}>
              <li>
                <NavLink
                  to={`/players/${slug}`}
                  state={{ player: fallbackPlayer, leagueSlug }}
                  className="myactive"
                  style={
                    dark
                      ? { color: "#fafafaff", backgroundColor: "blue" }
                      : { color: "#3F3E3E", backgroundColor: "blue" }
                  }>
                  Overview
                </NavLink>
              </li>

              <li>
                <NavLink
                  to={`/players/${slug}/news`}
                  state={{ player: fallbackPlayer, leagueSlug }}
                  className="linkname"
                  style={dark ? { color: "#fafafaff" } : { color: "#3E3F3F" }}>
                  News
                </NavLink>
              </li>

              <li>
                <NavLink
                  to={`/players/${slug}/statistics`}
                  state={{ player: fallbackPlayer, leagueSlug }}
                  className="linkname"
                  style={dark ? { color: "#fafafaff" } : { color: "#3F3E3E" }}>
                  Statistics
                </NavLink>
              </li>
            </ul>
          </menu>
        </section>

        {loading ? (
          <Skeleton dark={dark} count={6} />
        ) : error ? (
          <div
            style={{
              padding: "40px 20px",
              color: "red",
            }}>
            {error}
          </div>
        ) : !playerData ? (
          <div
            style={{
              padding: "40px 20px",
              color: dark ? "#fff" : "#161819",
            }}>
            No player data found.
          </div>
        ) : (
          <>
            <section className="secondsection">
              <h1
                className="h1"
                style={dark ? { color: "#fafafaff" } : { color: "#161819" }}>
                {fallbackPlayer?.name || player?.name} Stats & Profile
              </h1>
              {/* <p
        style={dark ? { color: "#cfcfcfff" } : { color: "#555" }}
      >
        {player?.team?.name} • {stats?.games?.position} •{" "}
        {stats?.league?.name} • Player Statistics & Career Information
      </p> */}

              <nav>
                <span style={{ color: "#249224" }}>
                  <strong
                    style={
                      dark ? { color: "#fafafaff" } : { color: "#3e3f3f" }
                    }>
                    Rating:
                  </strong>{" "}
                  {stats?.games?.rating || 0}
                </span>

                <span style={{ color: "#AD2E2E" }}>
                  <strong
                    style={
                      dark ? { color: "#fafafaff" } : { color: "#3e3f3f" }
                    }>
                    Nationality:
                  </strong>{" "}
                  {player?.nationality}
                </span>
              </nav>

              <nav>
                <span style={{ color: "#93931A" }}>
                  <strong
                    style={
                      dark ? { color: "#fafafaff" } : { color: "#3e3f3f" }
                    }>
                    Position:{" "}
                  </strong>{" "}
                  {stats?.games?.position}
                </span>

                <span style={{ color: "#4497C0" }}>
                  <strong
                    style={
                      dark ? { color: "#fafafaff" } : { color: "#3e3f3f" }
                    }>
                    Appearances:
                  </strong>{" "}
                  {stats?.games?.appearences}
                </span>
              </nav>

              <h1
                className="h1"
                style={dark ? { color: "#fafafaff" } : { color: "#161819" }}>
                Biography
              </h1>

              <p style={dark ? { color: "#dfdfdfff" } : { color: "#3e3f3f" }}>
                Born into the relentless rhythm of elite football in{" "}
                {player?.nationality}, this dynamic {stats?.games?.position} has
                carved out an important role for {stats?.team?.name} in the
                highly competitive {stats?.league?.name}
                during the {stats?.league?.season} season.
              </p>
            </section>

            <section className="thirdsection">
              <h1 style={dark ? { color: "#fafafaff" } : { color: "#161819" }}>
                Current form ( last 6 matches )
              </h1>

              <div>
                <nav
                  style={
                    dark
                      ? { backgroundColor: "#181818ff" }
                      : { backgroundColor: "white" }
                  }>
                  <NavLink
                    to={`/competition/${createSlug(stats?.league?.name)}/${stats?.league?.id}`}
                    style={{ textDecoration: "none", color: "inherit" }}>
                    <p
                      style={
                        dark ? { color: "#fafafaff" } : { color: "#3e3f3f" }
                      }>
                      {stats?.league?.name}
                    </p>
                  </NavLink>

                  <img
                    src={team?.logo}
                    alt={team?.name}
                    style={{ height: "60px", width: "60px" }}
                  />

                  <NavLink to={`/teams/${createSlug(team?.name)}-${team?.id}`}>
                    <p
                      style={
                        dark ? { color: "#fafafaff" } : { color: "#3e3f3f" }
                      }>
                      {team?.name}
                    </p>
                  </NavLink>

                  <span>
                    <h4
                      style={
                        dark ? { color: "#fafafaff" } : { color: "whitesmoke" }
                      }>
                      {stats?.goals?.total} Goals
                    </h4>
                    <h5
                      style={
                        dark ? { color: "#fafafaff" } : { color: "whitesmoke" }
                      }>
                      {stats?.games?.rating
                        ? Math.round(Number(stats.games.rating))
                        : 0}{" "}
                      Rating
                    </h5>
                  </span>
                </nav>
              </div>
            </section>
          </>
        )}
      </div>
    </>
  );
};

export default Player;
